import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const MoneyInput = ({
  onChange,
  hasValue,
  hasError,
  handleFocus,
  defaultValue,
  value,
  handleBlur,
}) => {
  return (
    <MoneyInput.StyledInput
      defaultValue={defaultValue}
      value={value}
      onBlur={handleBlur}
      hasError={hasError}
      hasValue={hasValue}
      onChange={onChange}
      onFocus={handleFocus}
      type="number"
      min="1"
      step="1"
    />
  );
};

MoneyInput.StyledInput = styled.input`
  border: ${(props) =>
    props.hasError
      ? `1px solid ${COLORS.primaryInputErrorBorder}`
      : `1px solid ${COLORS.primaryInputBorder}`};
  background: url(/assets/svg/icn-dollar-sign.svg) no-repeat scroll 16px 23px
    ${COLORS.primaryBackground};
  height: 74px;
  max-width: 369px;
  width: 369px;
  font-size: 16px;
  font-family: ${FONTS.special};
  color: ${COLORS.primaryInputText};
  font-size: 40px;
  line-height: 41px;
  padding: ${(props) => (props.hasValue ? '20px 0 9px 24px' : '20px 0px 17px 33px')};

  &:focus,
  &:hover {
    color: ${COLORS.secondaryInputText};
    border: 1px solid ${COLORS.secondaryInputBorder};
    outline: none;
  }
`;

MoneyInput.propTypes = {
  onChange: PropTypes.func,
  hasValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasError: PropTypes.bool,
  handleFocus: PropTypes.func,
  defaultValue: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleBlur: PropTypes.func,
};

export default MoneyInput;
